import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const APP_ID = process.env.REACT_APP_INSTAGRAM_APP_ID || "";
const REDIRECT_URI =
  process.env.REACT_APP_INSTAGRAM_REDIRECT_URI ||
  "https://n8ncdm.checkoutdm.com/webhook/checkoutdm-oauth-callback";
const SCOPES =
  process.env.REACT_APP_INSTAGRAM_SCOPES ||
  "instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments";

export async function connectToInstagram() {
  // 1) Try to get a CSRF state from our backend; fall back to client-generated.
  let state;
  try {
    const { data } = await axios.post(`${API}/oauth/instagram/state`);
    state = data.state;
  } catch (_e) {
    state =
      (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
      String(Date.now()) + Math.random().toString(36).slice(2);
  }
  sessionStorage.setItem("cdm_ig_state", state);

  if (!APP_ID) {
    // Config not set — surface a helpful error rather than 400 from Instagram
    const err = new Error(
      "Instagram App ID missing. Add REACT_APP_INSTAGRAM_APP_ID to frontend/.env"
    );
    err.code = "MISSING_APP_ID";
    throw err;
  }

  const params = new URLSearchParams({
    client_id: APP_ID,
    redirect_uri: REDIRECT_URI,
    response_type: "code",
    scope: SCOPES,
    state,
  });

  const url = `https://www.instagram.com/oauth/authorize?${params.toString()}`;
  window.location.assign(url);
}
